export default {"src":"/_next/static/media/logo-white.29ea3b4d.svg","height":32,"width":81,"blurWidth":0,"blurHeight":0};